export function sortedValues<T>(map: Map<string, T>, cmp: (a: T, b: T) => number): T[] {
  return Array.from(map.values()).sort(cmp)
}

export function sortedEntries<K, V>(map: Map<K, V>, cmp: (a: [K, V], b: [K, V]) => number): [K, V][] {
  return Array.from(map.entries()).sort(cmp)
}

export function sortedByKeyAsc(map: Map<string, unknown>): [string, unknown][] {
  return Array.from(map.entries()).sort(([a], [b]) => a.localeCompare(b))
}
